import { useMemo } from 'react';
import { useAppSelector } from '../../redux';
import { LngLat } from '../../types/Geo';
import DistanceMarkers from './DistanceMarkers';

const CustomRouteDistanceMarkers = () => {
  const segments = useAppSelector(state => state.customRoute.route.segments);

  const polylines = useMemo<LngLat[][]>(
    () =>
      segments
        .map<LngLat[]>(segment => segment.paths.flatMap(path => path.points).map(([lat, lng]) => [lng, lat] as LngLat))
        .filter(polyline => polyline.length >= 2),
    [segments]
  );

  return <DistanceMarkers polylines={polylines} />;
};

export default CustomRouteDistanceMarkers;
